import styled from 'styled-components'
import { Flex } from '../Flex'
import { FlexProps } from '../Flex/types'

export interface ContentWrapperProps extends FlexProps {
  topDivider?: boolean
  fullWidth?: boolean
}

export const ContentWrapper = styled(Flex)<ContentWrapperProps>`
  width: 100%;
  align-items: center;
  border-top: ${({ theme, topDivider }) => (topDivider ? `1px solid ${theme.colors.gray6}` : 'none')};

  @media screen and (min-width: ${({ theme }) => theme.siteWidth}px) {
    width: ${({ theme }) => theme.siteWidth}px;
  }

  @media screen and (max-width: ${({ theme }) => theme.siteWidth}px) {
    padding: ${({ fullWidth }) => (fullWidth ? '0' : '0 28px')};
    margin: 0 auto;
  }
`
